export default __webpack_public_path__ + "static/links-tera-01-2e14dfc551cc4c66788b4a73d716fa36.png";